import { el } from 'redom';

import application from 'application';

import {
  computeVoteChoicePercentage
} from './utilities';

import ActivePollChoice from './active-poll-choice';

class PollChoiceWithStats extends ActivePollChoice {

  constructor() {

    super();

    this.votedIconEl = el('span.poll-choice-voted-icon');
    this.choiceNameEl = el('span.poll-choice-name');
    this.choiceVoteSharePercentageEl = el('span.poll-choice-vote-share-percentage');

    this.pollChoiceButtonEl = el('button.poll-choice-details-container', [this.votedIconEl, this.choiceNameEl, this.choiceVoteSharePercentageEl]);
    this.percentageDisplay = el('.poll-choice-percentage-bar');

    this.el = el('li.poll-choice-list-item', [this.percentageDisplay, this.pollChoiceButtonEl]);

  }

  update(choice, index, choices, context) {

    const userId = application.getUser()._id;
    const voted = choice.voterIds.indexOf(userId) !== -1;

    if (voted === true) {
      this.votedIconEl.classList.add('voted');
    } else {
      this.votedIconEl.classList.remove('voted');
    }

    const votePercentage = computeVoteChoicePercentage(context.poll, choice);

    this.choiceNameEl.textContent = choice.name;
    this.choiceVoteSharePercentageEl.textContent = `${votePercentage}%`;
    this.percentageDisplay.style.width = votePercentage + '%';

    this.pollChoiceButtonEl.addEventListener('click', this.handleChoiceButtonClick.bind(this, index, choice, context.poll));

  }

}

export default PollChoiceWithStats;